import z from 'zod';

import { ELanguages } from '@enums/languages.enum';

export const sendEmailSearchParamsSchema = z.object({
  language: z.enum(ELanguages).default(ELanguages.Fr),
  to: z.email(),
});

export const sendEmailSchema = z.object({
  body: z.string().min(1, 'Message is required'),
  cc: z
    .object({
      value: z
        .email({ message: 'Cc must be valid email. (Ex: example@example.com)' })
        .trim()
        .toLowerCase(),
    })
    .array()
    .optional(),
  ccDraft: z.string().optional(),
  to: z
    .email({
      message: 'Email is required and must be valid. (Ex: example@example.com)',
    })
    .trim()
    .toLowerCase(),
  subject: z.string().min(1, 'Subject is required').max(998),
  attachments: z
    .object({
      id: z.string(),
    })
    .array()
    .optional(),
});

export type SendEmailDto = z.infer<typeof sendEmailSchema>;

export type SendEmailPayload = Omit<SendEmailDto, 'cc' | 'attachments'> & {
  attachments?: Array<string>;
  cc?: Array<string>;
  interventionId?: string;
  language: ELanguages;
  recipientType: 'requester' | 'provider';
  serviceRequestId: string;
};
